module.exports = __webpack_public_path__ + "media/pricing/DigitalProduct-mobile-98e19f6c.png";